import { Controller } from "stimulus"

export default class extends Controller {
  save(event) {
    const value = event.currentTarget.dataset.value;
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    // Sync sidebar Editor Mode buttons if visible
    const sidebarBtnGroup = document.querySelector('.editor-setting-btn-group[data-setting="editor_format"]');
    if (sidebarBtnGroup) {
      sidebarBtnGroup.querySelectorAll('.editor-setting-btn').forEach(btn => {
        btn.classList.remove('active');
        if (btn.dataset.value === value) {
          btn.classList.add('active');
        }
      });
    }

    const delivery = document.getElementById('publishForm')?._documentDelivery;
    if (delivery) {
      delivery.session.save(delivery.setSetting('editor_format', value));
      return;
    }

    fetch('/post_options/update_editor_format', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ editor_format: value })
    });
  }
}
